import { GetMoniUsers } from '@/domain/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { RemoteGeMoniUsersEvents } from '@/data/usecases/events'
import env from '@/main/config/env'

export const makeGetMoniUsersFactory = (): GetMoniUsers => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteGeMoniUsersEvents(url, httpClient)
}
